export const getPageMeta = (pageType) => {
  const baseUrl = 'https://www.phoenixai.my';
  
  const pageMetadata = {
    home: {
      title: 'Phoenix AI Malaysia | Enterprise AI Solutions Kuala Lumpur - Compliance, Security & Training',
      description: 'Phoenix AI Malaysia (Sdn Bhd, 1631340-A) - Kuala Lumpur based AI solutions provider. ISO 27001 certified. Specializing in Enterprise AI, PDPA Compliance, AI Training, Security & Automation for Malaysian SMEs and listed companies.',
      canonical: `${baseUrl}/`,
      ogImage: `${baseUrl}/logo-phoenix-ai.png`,
      keywords: 'Phoenix AI Malaysia, AI solutions Malaysia, AI services Kuala Lumpur, enterprise AI Kuala Lumpur, AI automation Malaysia, Malaysian AI company, AI consulting KL, intelligent automation Malaysia',
      robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    },
    about: {
      title: 'About Phoenix AI Malaysia | Leading AI Solutions Company Kuala Lumpur',
      description: 'Phoenix AI Malaysia (Sdn Bhd, 1631340-A) - Kuala Lumpur based AI leader serving Malaysian businesses. ISO 27001 & GDPR certified. Enterprise AI, PDPA compliance, and innovation excellence.',
      canonical: `${baseUrl}/about`,
      ogImage: `${baseUrl}/logo-phoenix-ai.png`,
      keywords: 'Phoenix AI Malaysia, AI company Malaysia, Kuala Lumpur AI solutions, Malaysian AI provider, enterprise AI Kuala Lumpur, local AI technology, AI expertise Malaysia',
      robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    },
    services: {
      title: 'Enterprise AI Services Malaysia | Compliance, Training, Security & Automation Solutions',
      description: 'Phoenix AI Malaysia provides enterprise-grade AI services for Malaysian businesses: AI Training, ISO 27001 Consultancy, ISO 9001 Consultancy, PDPA-compliant AI automation, AI-powered CCTV, and ASCEND AI Readiness Audit.',
      canonical: `${baseUrl}/services`,
      ogImage: `${baseUrl}/logo-phoenix-ai.png`,
      keywords: 'AI services Malaysia, AI solutions Kuala Lumpur, ISO 27001 Malaysia, AI training Malaysia, PDPA compliance AI, AI automation Malaysia, enterprise AI security, Malaysian AI company services',
      robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    },
    contact: {
      title: 'Contact Phoenix AI Malaysia | Enterprise AI Solutions in Kuala Lumpur',
      description: 'Contact Phoenix AI Malaysia for enterprise AI solutions, training, and consultancy. Serving Malaysian businesses from our Kuala Lumpur office. ISO 27001 certified, PDPA compliant.',
      canonical: `${baseUrl}/contact`,
      ogImage: `${baseUrl}/logo-phoenix-ai.png`,
      keywords: 'contact Phoenix AI Malaysia, AI consulting Kuala Lumpur, Malaysian AI company contact, AI services KL, enterprise AI Malaysia inquiry',
      robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    }
  };

  return pageMetadata[pageType] || pageMetadata.home;
};
